import {
  IconAppleColored as InternalIconAppleColoredRebranded,
  IconCaretLeftBold as InternalIconBackArrowRebranded,
  IconClose as InternalIconCloseRebranded,
  IconFacebookColored as InternalIconFacebookColoredRebranded,
  IconGlobe as InternalIconGlobeRebranded,
  IconGoogleColored as InternalIconGoogleColoredRebranded,
  IconEyeClosed as InternalIconHideRebranded,
  IconLock as InternalIconLockRebranded,
  IconEnvelopeSimple as InternalIconMailRebranded,
  IconEye as InternalIconShowRebranded,
  IconXCircle as InternalIconXCircleRebranded,
} from '@lessonnine/design-system.lib'
import React from 'react'
import { CURRENT_DS_VERSION } from 'src/dataLayer/localData/designSystem'
import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions'

const IconsMap = {
  [DS_VERSIONS.default]: {
    IconAppleColored: ({ props }) => <InternalIconAppleColoredRebranded size="large" {...props} />,
    IconBackArrow: InternalIconBackArrowRebranded,
    IconClose: InternalIconCloseRebranded,
    IconFacebookColored: ({ props }) => (
      <InternalIconFacebookColoredRebranded size="large" {...props} />
    ),
    IconGlobe: InternalIconGlobeRebranded,
    IconGoogleColored: ({ props }) => (
      <InternalIconGoogleColoredRebranded size="large" {...props} />
    ),
    IconHide: InternalIconHideRebranded,
    IconLock: InternalIconLockRebranded,
    IconMail: InternalIconMailRebranded,
    IconShow: InternalIconShowRebranded,
    IconXCircle: InternalIconXCircleRebranded,
  },
}

export default IconsMap[CURRENT_DS_VERSION]
